/* =========================================================
   Popup Newsletter — popup-newsletter.js
   Colocar em: assets/popup-newsletter.js
   ========================================================= */

(function () {
  'use strict';

  var STORAGE_KEY = 'popup_newsletter_last_shown';

  var popup   = document.getElementById('popup-newsletter');
  var closeBtn = document.getElementById('popup-newsletter-close');
  var form    = document.getElementById('popup-newsletter-form');
  var success = document.getElementById('popup-newsletter-success');

  if (!popup) return;

  var delayMs   = parseInt(popup.dataset.delay, 10)    || 5000;
  var reshowDays = parseInt(popup.dataset.reshowDays, 10) || 5;

  /* ── Verifica se deve mostrar ── */
  function shouldShow() {
    var lastShown = localStorage.getItem(STORAGE_KEY);
    if (!lastShown) return true;
    var diff = Date.now() - parseInt(lastShown, 10);
    return diff > reshowDays * 24 * 60 * 60 * 1000;
  }

  /* ── Abre popup ── */
  function openPopup() {
    popup.classList.add('is-visible');
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  /* ── Fecha popup ── */
  function closePopup() {
    popup.classList.remove('is-visible');
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  }

  /* ── Inicializa ── */
  function init() {
    if (!shouldShow()) return;

    setTimeout(openPopup, delayMs);

    /* Fechar pelo botão X */
    if (closeBtn) {
      closeBtn.addEventListener('click', closePopup);
    }

    /* Fechar clicando no overlay (fora da caixa) */
    popup.addEventListener('click', function (e) {
      if (e.target === popup) closePopup();
    });

    /* Fechar com ESC */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
        closePopup();
      }
    });

    /* Submit do form */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var emailInput = form.querySelector('input[type="email"]');
        if (!emailInput || !emailInput.value.trim()) {
          emailInput && emailInput.focus();
          return;
        }

        /* Shopify Customer API — adiciona subscriber */
        var formData = new FormData(form);

        fetch('/contact', {
          method: 'POST',
          body: formData,
          headers: { 'Accept': 'application/json' }
        })
        .then(function () {
          form.hidden = true;
          if (success) success.hidden = false;
          localStorage.setItem(STORAGE_KEY, String(Date.now()));
          setTimeout(closePopup, 2500);
        })
        .catch(function () {
          /* Fallback silencioso — mesmo assim fecha após um tempo */
          form.hidden = true;
          if (success) success.hidden = false;
          setTimeout(closePopup, 2500);
        });
      });
    }
  }

  /* Aguarda DOM pronto */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();